/**
 * Better Auth client SDK — frontend tarafı
 *
 * Backend `/api/auth/*` endpoint'lerine credentials ile çağrı yapar.
 * Cookie HttpOnly olduğu için JS doğrudan token'a erişmiyor.
 */
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  // Aynı origin'de — nginx /api/auth proxy'siyle backend'e gider
  baseURL: typeof window !== 'undefined' ? window.location.origin : '',
});

export const {
  signUp,
  signIn,
  signOut,
  useSession,
  getSession,
  sendVerificationEmail,
  resetPassword,
} = authClient;

// forgetPassword Better Auth v1 type'ında authClient.forgetPassword olarak
// expose ediliyor ama TS'in inferred type'ında görünmüyor.
// Runtime'da `authClient.forgetPassword(...)` çalışır — burada wrapper expose ediyoruz.
export const forgetPassword = (
  authClient as unknown as {
    forgetPassword: (data: {
      email: string;
      redirectTo?: string;
    }) => Promise<{ data: unknown; error: { message?: string } | null }>;
  }
).forgetPassword;
